// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1___726189bc36d37d0873e","cls2":"PaperImages-cls2___4d782bc34fb07676df8 PaperImages-cls1___726189bc36d37d0873e"};